// Admin credentials - change these if needed
export const ADMIN_CREDENTIALS = {
  email: "admin@idacoromania.ro",
  password: "IdacoAdmin2025!",
} as const;

export const SESSION_KEY = "admin_session_idaco";
